/**
 *  App component
 *
 *  @author    2024        김효민
 *  @author    2026-04-23  Bruce.Cheong    (디자인 개선)
 */

/** External import */
import { useLocation, useNavigate } from "react-router-dom";

/** Internal import */
import CSS from "./Navi.module.css";
import HomeLinkLogo from "../../Component/Elements/HomeLinkLogo/HomeLinkLogo";
import { NaviItemType } from "./interface/Navi.interface";

type NaviProps = {
    navi_item_list: NaviItemType[];
}

type NaviMenuItemProps = Pick<NaviItemType, "name" | "icon"> & {
    is_activated: boolean;
    onClickFc: () => void;
}

type NaviMenuItemListProps = {
    navi_item_list: NaviItemType[];
    pathname: string;
    onItemClick: (navigate_path: string) => void;
}

const Navi = (iProps: NaviProps) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    return (
        <>
            {/** PC, 테블릿의 대메뉴 */}

            <nav className={[CSS.Navi, "Navi"].join(" ")}>
                <div className={CSS.HomeLinkLogoWrap}>
                    <HomeLinkLogo />
                </div>

                <NaviMenuItemList
                    navi_item_list={iProps.navi_item_list}
                    pathname={pathname}
                    onItemClick={navigate}
                />
            </nav>

            {/** 모바일의 대메뉴 */}

            <nav className={[CSS.NaviMobile, "NaviMobile"].join(" ")}>
                <NaviMenuItemList
                    navi_item_list={iProps.navi_item_list}
                    pathname={pathname}
                    onItemClick={navigate}
                />
            </nav>
        </>
    );
}

export default Navi;

function NaviMenuItemList(iProps: NaviMenuItemListProps) {

    return (
        <ul className={[CSS.NaviMenuItemListWrap, "NaviMenuItemListWrap"].join(" ")}>
            {iProps.navi_item_list.map((item) => {
                return (
                    <NaviMenuItem
                        key={item.navigate}
                        name={item.name}
                        icon={item.icon}
                        onClickFc={() => iProps.onItemClick(item.navigate)}
                        is_activated={item.navigate === iProps.pathname}
                    />
                );
            })}
        </ul>
    );
}

function NaviMenuItem(iProps: NaviMenuItemProps) {
    return (
        <li
            className={[CSS.NaviMenuItem, "NaviMenuItem", iProps.is_activated ? CSS.selected : ""].join(" ")}
            onClick={iProps.onClickFc}
        >
            <span className={[CSS.IconWrap, "IconWrap"].join(" ")}>
                {iProps.icon && <iProps.icon />}
            </span>
            <span className={[CSS.TitleWrap, "TitleWrap"].join(" ")}>
                {iProps.name}
            </span>
        </li>
    );
}